import { serverClient } from '@obvio/server'

import { schema } from '@/api/schema'
import {
  ArticleCategorySelect,
  BlogIndex,
} from '@/components/Blog/BlogIndex/BlogIndex'
import { blogPageCount } from '@/components/Blog/consts'
import { normalizeArticle } from '@/components/Blog/normalizeArticle'
import { Breadcrumbs } from '@/components/Breadcrumbs'
import { Layout } from '@/components/Layout'
import { PageSeo } from '@/components/PageSeo'
import { REVALIDATE_SECONDS } from '@/constants/revalidate'
import { SITE_NAME } from '@/constants/seo'

import type { ArticleCategory } from '@/components/Blog/BlogIndex/BlogIndex'
import type { GetStaticPropsContext, GetStaticPropsResult } from 'next'
import type { ReactElement } from 'react'

export async function getStaticProps(
  ctx: GetStaticPropsContext,
): Promise<GetStaticPropsResult<PageProps>> {
  const client = await serverClient(schema, { ...ctx, isAdmin: true })

  const categories = await client.query('getAllLatestArticles', {
    select: ArticleCategorySelect,
  })
  const articles = await client.query('getArticles', { select: { id: true } })

  const normalized = categories.map((category) => ({
    ...category,
    articles: category.articles
      .map(normalizeArticle)
      .sort((a, b) => (new Date(a.createdAt) < new Date(b.createdAt) ? 1 : -1)),
  }))

  return {
    ...client.ssrData({
      categories: normalized,
      pages: blogPageCount(articles.length),
    }),
    revalidate: REVALIDATE_SECONDS,
  }
}

type PageProps = {
  categories: ArticleCategory[]
  pages: number
}

const TITLE = `Blog - ${SITE_NAME}`
const DESCRIPTION =
  'Dziennik hotelowy Poziom 511: wydarzenia, SPA, wino i Jura Krakowsko-Częstochowska widziane z hotelu u stóp Zamku Ogrodzieniec.'

function Page({ categories, pages }: PageProps): ReactElement {
  return (
    <>
      <PageSeo path="blog" title={TITLE} description={DESCRIPTION} />
      <Breadcrumbs trail={[{ name: 'Blog', path: 'blog' }]} />
      <Layout type="Główny">
        <BlogIndex categories={categories} pages={pages} />
      </Layout>
    </>
  )
}

export default Page
